import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";
function DireccionType(props) {
  const { history } = props;
  const [DireccionTypeStateUpdate, setDireccionTypeStateUpdate] = useState([]);
  const [DireccionTypeState, setDireccionTypeState] = useState([]);
  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [update, setUpdate] = useState(false);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });

  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "address_types?skip=0&limit=100&is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);

        setDireccionTypeStateUpdate(JSON.parse(responseJsonUpdate));
        setDireccionTypeState(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }

    llamadaApi();
  }, [update, history, usuario]);

  const [formularioState, setFormularioState] = useState({
    name: "",
  });

  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (event) => {
    setFormularioState({
      ...formularioState,
      [event.target.name]: event.target.value,
    });
  };
  let crearDireccionType = async (event) => {
    event.preventDefault();
    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      let response = await fetch(Parametros.post + "address_types", {
        method: "POST",
        body: JSON.stringify(formularioState),
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      });
      let responseJson = await response.json();

      if (response.status === 200 || response.status === 201) {
        alert("ok");
        setUpdate(!update);
        setEditable({});
        document.getElementById("formularioBusqueda").reset();
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      } else {
        alert(responseJson.detail);
      }
    } else {
      // Do nothing!
      setEditable({});
      // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
    }
  };

  let DireccionTypeHandleChange = (index, e) => {
    let newList = DireccionTypeState;
    newList[index][e.target.name] = e.target.value;
    setDireccionTypeState(JSON.parse(JSON.stringify(newList)));
  };
  let confirmarEdicion = async (item) => {
    if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
      let response = await fetch(
        Parametros.urlApi +
          "address_types/" +
          item.address_type_id +
          "?name=" +
          item.name,
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      let responseJson = await response.json();

      if (response.status === 200 || response.status === 201) {
        alert("ok");
        setUpdate(!update);
        setEditable({});
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      } else {
        alert(responseJson.detail);
        setUpdate(!update);
      }
    } else {
      // Do nothing!
      setEditable({});
      // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
    }
  };
  let cancelarEdicion = () => {
    const nuevoObjeto = JSON.parse(JSON.stringify(DireccionTypeStateUpdate));
    setDireccionTypeState(nuevoObjeto);
    setEditable({});
  };
  let editar = (id) => {
    setDireccionTypeState(JSON.parse(JSON.stringify(DireccionTypeStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Tipo de dirección"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearDireccionType}>
          <div className="col-md-4">
            <h5>Tipo de dirección </h5>
            <input
              onChange={handleStageForm}
              name="name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(DireccionTypeState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Tipo de dirección"]}
          ></Table>

          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Tipo de dirección"]}></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {DireccionTypeState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.address_type_id}>
                      {editable === item.address_type_id ? (
                        <>
                          <td>{item.address_type_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                DireccionTypeHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.address_type_id}</td>
                          <td>{item.name} </td>
                          <td>
                            <abbr title="Editar Elemento ">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.address_type_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`address_type/${item.address_type_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(DireccionTypeState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
        </div>
      </div>
    </div>
  );
}

export default withRouter(DireccionType);
